module.exports = __webpack_public_path__ + "img/wechat.ab7c421a.png";